module.exports = __webpack_public_path__ + "img/bruna.dec72c35.png";